import { useEffect, useState } from 'react';
import {
  Grid, Divider, FormControl, FormControlLabel, Paper,
  FormHelperText, Radio, RadioGroup, Typography, Button,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@mui/material';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import ListDetail from "../ListDetail";
import {
  checkEmail, sendCodeEmail, getCode, editAvatar, editDatosPersonales,
  editShare, editEmail, verifySavePhone, deleteAccount
} from '../../../actions/users';
import StatusModal from '../../modals/StatusModal';
import CodeModal from '../../modals/CodeModal';
import CrearPassModal from '../../modals/CrearPassModal';
import { SimpleLoading } from '../../common/Loading';

import { useSelector, useDispatch } from 'react-redux';

const INITIAL_CODE = { user: null, validate: null, type: "EMAIL" };
const INITIAL_MODAL = { show: false, type: "SUCCESS" };

const MainPerfil = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.user.user);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const initialState = {
    name: false,
    tel: false,
    email: false,
    nacimiento: false,
    sexo: false,
    password: false
  };
  const [isEditing, setIsEditing] = useState({
    ...initialState
  });
  const [data, setData] = useState({});
  const [date, setDate] = useState(null);
  const [modalStatus, setModalStatus] = useState(INITIAL_MODAL);
  const [modalCode, setModalCode] = useState(false);
  const [modalPass, setModalPass] = useState(false);
  const [code, setCode] = useState(INITIAL_CODE);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setData({
      name: user.name,
      apellido: user?.apellido ?? '',
      tel: user.tel,
      email: user.email,
      nacimiento: user.nacimiento || '',
      sexo: user.sexo || '',
      share: user.share || '0',
      password: ''
    })
  }, [user]);

  const cambiarData = e => { // Cambia el valor de "data" en el input editable
    setData({
      ...data,
      [e.target.name]: e.target.value
    })
  }

  const cambiarImg = async e => { //Camia la imagen del del perfil
    e.preventDefault();
    let file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('carpeta', `users/${user._id}`);
      formData.append('nombre', user._id);

      await dispatch(editAvatar(formData));
    }
  }

  const editarDatosPersonales = async e => { // Edita los datos personales del usuario (nombre, apellido, fecha de nacimiento, sexo)
    const info = {
      nombre: data.name,
      apellido: data.apellido,
      sexo: data.sexo,
      birth: date ? moment(date).format('DD-MM-YYYY') : ''
    }

    await dispatch(editDatosPersonales(info, user._id));
    setIsEditing({
      ...initialState
    })
  }

  const editarShare = async e => { // Edita la opción de compartir datos del usuario
    const info = {
      share: e.target.value
    }
    await dispatch(editShare(info, user._id));
  }

  const editarEmail = async e => {
    if (e.key !== 'Enter') return;

    if (data.email == user.email) {
      return setIsEditing({ ...initialState });
    }

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emailValido = regex.test(data.email);
    if (!emailValido) return setModalStatus({ type: "ERROR", show: true, message: "El email no es válido" });

    try {
      setLoading(true);

      const emailExistente = await checkEmail(data.email);
      if (emailExistente) return setModalStatus({ type: "ERROR", show: true, message: "Este email ya esta en uso" });

      const info = {
        email: data.email,
        subject: "verificacion",
        nombre: user.name
      };
      const enviado = await sendCodeEmail(info, user._id);

      if (enviado.data.codigo) {
        setCode({
          user: null,
          validate: enviado.data.codigo,
          type: "EMAIL",
        });
        setModalCode(true);
      } else {
        setModalStatus({
          show: true,
          type: "ERROR",
          message: "Ocurrió un error al enviar el código de verificación",
        });
      }
    } catch (error) {
      console.log("ERROR ", error);
      setModalStatus({
        type: "ERROR",
        show: true,
      });
    } finally {
      setLoading(false);
    }
  }

  const validateCodeEmail = async () => {
    if (!code.user || code.user == "") {
      setLoading(false);
      return setModalStatus({
        show: true,
        type: "ERROR",
        message: "Por favor, ingresa el código que se mandó a tu correo electrónico",
      });
    }

    if (Number(code.validate) !== Number(code.user)) {
      setLoading(false);
      return setModalStatus({
        show: true,
        type: "ERROR",
        message: "Código incorrecto. Por favor, intenta de nuevo."
      });
    }

    setLoading(true);
    setModalCode(false);

    const info = {
      email: data.email,
      subject: "verificacion",
      nombre: user.name
    }
    try {
      await dispatch(editEmail(info, user._id));
      setModalStatus({
        show: true,
        type: "SUCCESS",
        message: "Correo electrónico actualizado correctamente"
      });
      cancelValidateCode();
    } catch (error) {
      console.log('ERROR ', error);
      setModalStatus({ show: true, type: "ERROR" });
    } finally {
      setLoading(false);
    }
  }

  const validateCodePhone = async () => { // Validar el código de verificación del teléfono
    if (!code.user || code.user == "" || code.user.length < 4) {
      setLoading(false);
      return setModalStatus({
        show: true,
        type: "ERROR",
        message: "Por favor, ingresa el código que se mandó a tu celular",
      });
    }

    try {
      setLoading(true);
      const res = await dispatch(verifySavePhone({ tel: data.tel, code: code.user }, user._id));
      console.log(res);
      if (res) { // Si la verificación fue exitosa
        setLoading(false);
        setModalStatus({
          show: true,
          type: "SUCCESS",
          message: "Teléfono actualizado correctamente"
        });
        cancelValidateCode();
      } else {
        setLoading(false);
        setModalStatus({
          show: true,
          type: "ERROR",
          message: "Código incorrecto. Por favor, intenta de nuevo."
        });
      }
    } catch (error) {
      console.log('ERROR ', error);
      setModalStatus({ show: true, type: "ERROR" });
    } finally {
      setLoading(false);
    }
  }

  const cancelValidateCode = () => {
    setIsEditing({
      ...initialState
    });
    setCode(INITIAL_CODE);
    setModalCode(false);
    setLoading(false);
  }

  const editarTel = async e => { // Editar el teléfono del usuario
    if (e.key !== 'Enter') return;

    if (data.tel == user.tel) {
      return setIsEditing({ ...initialState });
    }

    const info = {
      tel: data.tel
    }

    try {
      setLoading(true);
      const enviado = await getCode("celular", info);
      if (enviado) {
        setModalCode(true);
        setCode({ ...code, type: "PHONE" });
      } else {
        setModalStatus({
          show: true,
          type: "ERROR",
          message: "Ocurrió un error al enviar el código de verificación",
        });
      }
    } catch (error) {
      console.log("ERROR ", error);
      setModalStatus({
        type: "ERROR",
        show: true,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Grid container spacing={1} mb={2} size={12}>
      <SimpleLoading open={loading} />
      <CodeModal
        show={modalCode}
        changeCode={(value) => setCode({ ...code, user: value })}
        validateCode={() => {
          if (code.type == "EMAIL") return validateCodeEmail();
          return validateCodePhone();
        }}
        cancel={cancelValidateCode}
        type={code.type}
      />
      <CrearPassModal
        show={modalPass}
        handleClose={() => setModalPass(false)}
        setModalStatus={setModalStatus}
        setModalPass={setModalPass}
      />
      <StatusModal
        closedModal={() => setModalStatus(INITIAL_MODAL)}
        show={modalStatus.show}
        type={modalStatus.type}
        message={modalStatus?.message ?? null}
      />

      {/* Header Section */}
      <Grid size={12} container justifyContent="space-between" alignItems="center" mb={3}>
        <Grid>
          <Typography variant="h3" color="primary">
            Datos Personales
          </Typography>
          <Typography variant="body2" color="#737791">
            Información básica de tu perfil
          </Typography>
        </Grid>
        <Grid hidden={isEditing.name}>
          <Button
            variant="contained"
            startIcon={<DriveFileRenameOutlineIcon />}
            color='secondary'
            onClick={() => {
              // Toggle all edit fields
              const newState = !isEditing.name;
              setIsEditing({
                ...initialState,
                name: newState,
                nacimiento: newState,
                sexo: newState,
              });
            }}
          >
            Editar
          </Button>
        </Grid>
      </Grid>

      {/* List Detail Section */}
      <Paper sx={{ width: '100%' }} >
        <ListDetail
          user={user}
          info={data}
          date={date}
          isEditing={isEditing}
          setDate={setDate}
          setIsEditing={setIsEditing}
          setModalPass={setModalPass}
          cambiarImg={cambiarImg}
          cambiarData={cambiarData}
          editarEmail={editarEmail}
          editarTel={editarTel}
          editarDatosPersonales={editarDatosPersonales}
        />

        <Grid size={12} mt={3}>
          <Divider />
        </Grid>

        {/* Share Section */}
        <Grid size={12} p={3}>
          <Typography variant="h6" color="#464646" mb={2}>
            Compartir mi correo y celular con:
          </Typography>
          <FormControl fullWidth>
            <RadioGroup
              row
              aria-labelledby="share_info"
              name="share"
              value={data.share || '0'}
              onChange={editarShare}
            >
              {/* Usamos Grid para controlar perfectamente el layout */}
              <Grid container spacing={3} sx={{ justifyContent: 'space-between' }} size={12}>
                {[
                  { value: '1', label: 'Todos', ayuda: 'Cualquier persona que entre a mi página' },
                  { value: '2', label: 'Miembros', ayuda: 'Miembros registrados a OneService' },
                  { value: '3', label: 'Conexiones', ayuda: 'Miembros con quienes he trabajado' },
                  { value: '0', label: 'Nadie', ayuda: 'Nadie podrá ver mis datos de contacto' },
                ].map((opcion) => (
                  <Grid key={opcion.value} size={{ xs: 12, sm: 6, md: 3 }}>
                    <FormControlLabel
                      value={opcion.value}
                      control={<Radio sx={{ color: "#D8DADC" }} />}
                      label={opcion.label}
                      sx={{
                        margin: 0,
                        '& .MuiFormControlLabel-label': { fontWeight: 500 }
                      }}
                    />
                    <FormHelperText className='help-input' sx={{ fontSize: '0.7rem' }}>
                      {opcion.ayuda}
                    </FormHelperText>
                  </Grid>
                ))}
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>
      </Paper>

      {/* Delete Account Section */}
      <Grid size={12} sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        <Button 
          variant="outlined" 
          color="error" 
          onClick={() => setOpenDeleteDialog(true)}
          sx={{ borderRadius: '20px', px: 4 }}
        >
          Eliminar mi cuenta
        </Button>
      </Grid>

      {/* Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" color="error">
          {"¿Estás seguro de eliminar tu cuenta?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Esta acción es irreversible. Se borrarán tus datos personales de forma permanente y 
            perderás el acceso a la plataforma. Todos tus servicios y páginas serán dados de baja.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => {
            setOpenDeleteDialog(false);
            dispatch(deleteAccount(navigate));
          }} color="error" variant="contained" autoFocus>
            Eliminar definitivamente
          </Button>
        </DialogActions>
      </Dialog>

    </Grid>
  );
};

export default MainPerfil;